import { Box } from "@chakra-ui/react"
import { InvitationsQueryVariables } from "@pathwright/graphql-client/src/generated"
import Invitations from "../../invitation/Invitations"
import { useShareUIContext } from "../shared/ShareUIContextProvider"

export function getInvitationsContext(context: {
  type: "group" | "cohort"
  typeId: number
}): InvitationsQueryVariables["context"] {
  switch (context.type) {
    case "group":
      return {
        community_group_id: context.typeId
      }
    default:
      return {
        [`${context.type}_id`]: context.typeId
      }
  }
}

const TrackTab = () => {
  const { context } = useShareUIContext()

  return (
    <Box minH="300px" p={"var(--card-padding)"} pt={0}>
      <Invitations context={getInvitationsContext(context)} />
    </Box>
  )
}

export default TrackTab
